import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { getOnEnter } from '../_utils';
import styles from './card.module.scss';
import { CardAction } from './card-content/card-action';
import { CardBody } from './card-content/card-body';
import { CardFooter } from './card-content/card-footer';
import { CardHeader } from './card-content/card-header';
export const Card = ({ children, isSelected = false, noBorder = false, isDisabled = false, isTabDisabled = false, data = '', onClick = _.noop, className, style, borderClassName, ...restProps }) => {
    const cardWrapperClasses = cx(className, noBorder ? styles.cardWrapperNoBorder : styles.cardWrapper, borderClassName, {
        [styles.selected]: isSelected,
        [styles.disabled]: isDisabled,
    });
    const childElements = React.Children.toArray(children);
    /** This helper function either retun valid react element or undefined */
    const getChildren = (type) => childElements.find((child) => child.type === type);
    const bodyWrapperClass = cx(styles.cardBodyWrapper, {
        /** When header is not present, Action and Body present, need to decrease the width of the body,
         since Action button overlaps on body */
        [styles.bodyWidthAdjust]: getChildren(CardAction) &&
            !getChildren(CardHeader) &&
            getChildren(CardBody),
    });
    const handleClick = (event) => {
        event.stopPropagation();
        onClick(data);
    };
    return (React.createElement("div", { className: cardWrapperClasses, style: style || {}, tabIndex: isDisabled || isTabDisabled ? -1 : 0, role: isDisabled ? undefined : 'button', onClick: isDisabled ? undefined : handleClick, onKeyDown: isDisabled
            ? undefined
            : getOnEnter((event) => handleClick(event)), ...restProps },
        getChildren(CardAction),
        getChildren(CardHeader),
        getChildren(CardBody) && (React.createElement("div", { className: bodyWrapperClass }, getChildren(CardBody))),
        getChildren(CardFooter)));
};
//# sourceMappingURL=card.js.map